import React from "react";
import Logo from "@common/Logo";
import AvatarWidget from "@/components/header/AvatarWidget";
import FacilityPicker from "@/components/header/FacilityPicker";
import HelpWidget from "@/components/header/HelpWidget";
import MessagesWidget from "@/components/header/MessagesWidget";
import NotificationsWidget from "@/components/header/NotificationsWidget";
import CreateButton from "@/components/header/CreateButton";
import {useAuth0} from "@auth0/auth0-react";
import {LeftRegion, RightRegion, Wrapper} from "@/components/header/GlobalNavBar.styles";

type Props = {
  isFacilityContext: boolean;
  hideFacilityPicker: boolean;
}

function GlobalNavBar(props: Props) {
  const { isAuthenticated} = useAuth0();

  return (
    <Wrapper>
      <LeftRegion>
        <Logo />
        {isAuthenticated && props.isFacilityContext && <CreateButton />}
      </LeftRegion>
      <RightRegion>
        {isAuthenticated && (
          <>
            {props.isFacilityContext && <MessagesWidget />}
            {props.isFacilityContext && <NotificationsWidget />}
            <HelpWidget />
            {props.isFacilityContext && !props.hideFacilityPicker && <FacilityPicker />}
          </>
        )}
        <AvatarWidget />
      </RightRegion>
    </Wrapper>
  );
}

export default React.memo(GlobalNavBar);
